import { getLocationById } from "../locationAPI";

/**
 * Makes a call to get the Location
 * @param {string} locationIds - to get the Location valid "id" or "all"
 * @returns - returns location data
 */
export const loadLocation = async (locationIds, isDropDown = true) => {
  try {
    const response = await Promise.all(locationIds.map((item) => item && getLocationById(item)));

    let formatLocationData = [];
    // if the data is required for dropdown then only id and name is enough else will send all the data
    {
      isDropDown
        ? (formatLocationData = response?.map((locationItem) => {
            return {
              id: locationItem?._id,
              name: locationItem?.name,
            };
          }))
        : (formatLocationData = response?.map((locationItem) => {
            return {
              id: locationItem?._id,
              imageId: locationItem?.imageId,
              latitude: locationItem?.latitude,
              longitude: locationItem?.longitude,
              name: locationItem?.name,
              hostId: locationItem?.hostId,
              amenities: locationItem?.amenities,
              visibility: locationItem?.visibility,
            };
          }));
    }
    console.log("formatLocationData: ", formatLocationData);
    formatLocationData?.length > 0 && formatLocationData.sort((a, b) => a.id.localeCompare(b.id));
    return formatLocationData;
  } catch (err) {
    console.log("Error getting the Location", err.msg || err);
  }
};
